/**
 * Circle Tickers – animate progress pies to 100% with staggered starts
 */
document.addEventListener('DOMContentLoaded', function () {
  var DURATION = 1400; // ms for a single pie to fill 0 → 100%
  var STAGGER  = 300;  // ms between each pie's start within a group

  // Reset all pies to 0 immediately so the PHP inline value doesn't show
  document.querySelectorAll('.progress-pie').forEach(function (pie) {
    pie.style.setProperty('--fill-percent', '0%');
  });

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animatePie(pie, delay) {
    setTimeout(function () {
      var startTime = null;

      function step(timestamp) {
        if (startTime === null) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / DURATION, 1);
        pie.style.setProperty('--fill-percent', (easeOutCubic(progress) * 100).toFixed(2) + '%');
        if (progress < 1) requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    }, delay);
  }

  document.querySelectorAll('.circle-tickers-grid').forEach(function (grid) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(grid);

        grid.querySelectorAll('.progress-pie').forEach(function (pie, index) {
          animatePie(pie, index * STAGGER);
        });
      });
    }, { threshold: 0.3 });

    observer.observe(grid);
  });
});
